module.exports = __webpack_public_path__ + "img/user_profile_1.e80ed3e9.png";